<template>
	<div style="margin-top: -1rem;">
		<div class="actDiv">
			<label>小区</label>
			<a-select  style="width:12rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="theNeighbor" placeholder="请选择小区" label-in-value
						    option-filter-prop="children"  :filter-option="filterOption" show-search  @change="queryData">
				<a-select-option v-for="(item,index) in neighborList" :key="item.pId" :value="item.pId">{{item.neighborName}}</a-select-option>
			</a-select>
			<a-button  size="small"  icon="bulb"  @click="settleAllSubmit" :disabled="theNeighbor==undefined || settleSubmitFlag ==true"  style="margin-left: 1rem;">结算小区</a-button>
			<a-button size="small" v-show="false"   icon="bell"   :loading="warningSubmitFlag" @click="warningAllSubmit" style="margin-left: 1.625rem;">提醒缴费</a-button>
			<label style="margin: 0  0.3125rem 0 2rem ;">用量</label>
			<a-input-number v-model="startNum" :min="0" ::precision="0"/>
			<label style="margin: 0 0.3125rem;" > - </label>
			<a-input-number  v-model="endNum"  :min="0" :precision="0"/>
			<a-button size="small"   icon="search" @click="queryData" style="margin-left: 1.25rem;">查找</a-button>
			<a-button size="small"   icon="cloud-download" @click="exportException" style="margin-left: 1.25rem;">导出异常</a-button>
		</div>
		<vxe-table  align="center" :data="settleList"  border max-height="600"   ref="mTable" show-overflow="title" size="mini"
						  resizable highlight-hover-row :loading="settleListLoading"  :cell-style="cellClassName"
						  @checkbox-all="selectAllEvent" @checkbox-change="selectChangeEvent"
						  :checkbox-config="{trigger: 'row', highlight: true, range: true}">
			<vxe-table-column type="checkbox" width="45"></vxe-table-column>
			<vxe-table-column title="用户号" field="customerNum" ></vxe-table-column>
			<vxe-table-column title="用户名" field="CustomerName" ></vxe-table-column>
			<vxe-table-column title="手机" field="CustomerMobile" ></vxe-table-column>
			<vxe-table-column title="余额" field="CustomerBalance" ></vxe-table-column>
			<vxe-table-column title="集中器" field="GPRSAddr"></vxe-table-column>
			<vxe-table-column title="采集器地址" field="CollectorAddr"></vxe-table-column>
			<vxe-table-column title="表地址" field="MeterAddr" ></vxe-table-column>
			<vxe-table-column title="表状态" field="MeterState"  :formatter="getMeterState"></vxe-table-column>
			<vxe-table-column title="表类型" field="Remote" :formatter="getMeterRemoteType"></vxe-table-column>
			<vxe-table-column title="换表用量" field="usedread"></vxe-table-column>
			<vxe-table-column title="扣费读数" field="deread"></vxe-table-column>
			<vxe-table-column title="阶梯起始" field="destartread"></vxe-table-column>
			<vxe-table-column title="表读数" field="readdata" ></vxe-table-column>
			<vxe-table-column title="换表底数" field="changend"></vxe-table-column>
			<vxe-table-column title="抄表时间" field="readtime" :formatter="getTimeFormatter"></vxe-table-column>
			<vxe-table-column title="单价" field="PriceKindName"></vxe-table-column>
			<vxe-table-column title="用量">
				<template #default="{ row }">
					<span :style="useCountStyle(row)">
						{{getUseCount(row)}}
					</span>
				</template>
			</vxe-table-column>
			<vxe-table-column title="操作" field="PID" width="190">
				<template #default="{ row }">
					<a-button  size="small"  type="link"  @click="showUpdateView(row)">修改</a-button>
					<a-popconfirm title= "确定要结算?" ok-text="确定" cancel-text="取消" @confirm="singleSettleSubmit(row)">
						<a-button  size="small"  type="link">单个结算</a-button>
					</a-popconfirm>
					<a-button size="small"  type="link" @click="showHistoryUseCount(row)">历史用量</a-button>
				</template>
			</vxe-table-column>
		</vxe-table>
		<vxe-table size="mini"  align="center" :data="useCountList"  resizable border style="margin-top: 1.25rem; width: 18.75rem;">
			<vxe-table-column title="单价" field="PriceKindName"></vxe-table-column>
			<vxe-table-column title="用量" field="useCount"></vxe-table-column>
		</vxe-table>
		<a-modal title="修改表读数" :visible="showUpdateFlag" :confirmLoading="updateLoading"
						@ok="updateMeterRead" @cancel="cancelUpdateMeterRead">
			<div  class="chargeDiv" style="margin-top: 0.75rem;">
				<label>表读数：</label>
				<a-input-number  v-model="newMeterRead" :min ="0" :precision="0" style="width:15rem;" :allowClear="true"/>
			</div>
		</a-modal>
		<a-drawer title="历史用量"  :visible="showHistoryFlag" width="520" @close="showHistoryFlag = false" :destroyOnClose="true"  :maskClosable="true">
			<ShowHistoryUseCount  :customerId="theSettleObj.PID"/>
		</a-drawer>
	</div>
</template>
<script>
	import ShowHistoryUseCount from '../components/ShowHistoryUseCount.vue'
	export default{
		components:{
			ShowHistoryUseCount,
		},
		data(){
			return {
				showHistoryFlag:false,
				theNeighbor:undefined,
				neighborList:[],
				settleList:[],
				useCountList:[],
				settleSubmitFlag:false,
				warningSubmitFlag:false,
				settleListLoading:false,
				settleUseCountLoading:false,
				showUpdateFlag:false,
				updateLoading:false,
				startNum:null,
				endNum:null,
				newMeterRead:null,
				theSettleObj:{},
				themodal:null,
				selectedRowKeys:[],
			}
		},
		methods:{
			getMeterRemoteType({cellValue}){
				if(cellValue == 1){
					return '远传表';
				}else{
					return '非远传表';
				}
			},
			useCountStyle:function(row){
				console.log(row.averageCount);
				let style= null;
				let useCount = row.readdata+row.changend-row.deread;
				if(useCount>50){
					style = {
						color:'#ed4014',
					}
				}else if(useCount<0){
					style = {
						color:'#4285F4',
					}
				}else if((useCount - row.averageCount)>=10){
					style = {
						color:'#ff9900',
					}
				}
				return style;
			},
			showHistoryUseCount:function(row){
				this.theSettleObj = row;
				this.showHistoryFlag = true;
			},
			cellClassName({ row, rowIndex, column }){
				let style = null;
				if(this.selectedRowKeys.includes(row.PID)){
					style = {
						backgroundColor: '#FFE48A',
						'color':'#000',
						fontFamily:"arial,sans-serif",
					}
				}else if(column.property == 'MeterState'){
					if(row.MeterState !=1){
						style = {
								backgroundColor: '#ffee00',
								color: '#ff0000',
						}
					}else{
							style = {
									'color':'#000',
									fontFamily:"arial,sans-serif"
							}
					}
				}else{
					style = {
							'color':'#000',
							fontFamily:"arial,sans-serif"
					}	
				}	
				return style;
			},
			scrollSome:function(){
				this.$refs.mTable.refreshScroll();
			},
			 selectAllEvent ({ checked, records }) {
			 	if(checked){
			 		for(var i = 0;i<records.length;i++){
			 			this.selectedRowKeys.push(records[i].PID);
			 		}
			 	}else{
			 		this.selectedRowKeys = [];
			 	}
			 },
			 selectChangeEvent({ checked, records }) {
			 	this.selectedRowKeys = [];
			 	for(var i = 0;i<records.length;i++){
			 		this.selectedRowKeys.push(records[i].PID);
			 	}
			 },
			singleSettleSubmit:function(item){
				this.theSettleObj = item;
				let url = this.Api.getLastUrl(this.Api.CHARGE_SETTLE_SINGLE_URL);
				let param = {meterId:this.theSettleObj.MID,neighborId:this.theNeighbor.key};
				this.settleListLoading = true;
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.settleListLoading = false;
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success('结算成功');
						this.settleSearch();  
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.settleListLoading = false;
					console.log(error);
				});
			},
			warningAllSubmit:function(){
				if(this.selectedRowKeys.length == 0){
					this.$message.error('请选择用户');
					return ;
				}
				this.warningSubmitFlag = true;
				let url = this.Api.getLastUrl(this.Api.CHARGE_WARNING_ALL_URL);
				let param = {customerIds:this.selectedRowKeys.join(",") ,neighborName:this.theNeighbor.label};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.warningSubmitFlag = false;
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success('操作成功');
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.warningSubmitFlag = false;
					console.log(error);
				});				
			},
			settleAllSubmit:function(){
				let name = this.theNeighbor.label;
				this.themodal = this.$confirm({
					title:'确定要结算'+name+'?',
					content:'',
					okType: 'warning',
					centered:true,
					onOk: h=>{
						this.realSettleAllSubmit();
					},
				});
			},
			realSettleAllSubmit:function(){
				this.themodal.destroy();
				this.settleSubmitFlag = true;
				 let url = this.Api.getLastUrl(this.Api.CHARGE_SETTLE_ALL_URL);
				 let param = {neighborId:this.theNeighbor.key};
				 this.Api.fetchPostWithForm(url,param).then((data)=>{
					 this.settleSubmitFlag = false;
					 let code = data.data.code;
					 let msg = data.data.message;
					 if(code == this.Api.HTTP_OK_CODE){
					 	this.$message.success('结算小区成功');
					 	this.queryData();
					 }else{
					 	this.$message.error(msg);
					 }
				 }).catch((error)=>{
					 this.settleSubmitFlag = false;
					 console.log(error);
				 });
			},
			updateMeterRead:function(){
				if(this.newMeterRead == null || this.newMeterRead.length == 0){
					this.$message.error('请输入表读数');
					return;
				}
				this.updateLoading = true;
				let url = this.Api.getLastUrl(this.Api.READ_METER_UPDATE_READ_URL);
				let param = {meterId:this.theSettleObj.MID,read:this.newMeterRead};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.updateLoading = false;
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.cancelUpdateMeterRead();
						this.$message.success('表读数修改成功');
						this.queryData();  
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.updateLoading = false;
					console.log(error);
				});
			},
			cancelUpdateMeterRead:function(){
				this.showUpdateFlag = false;
				this.newMeterRead = null;
			},
			queryData:function(){
				this.selectedRowKeys = [];
				if(this.theNeighbor == undefined){
					this.$message.error('请选择小区');
					return ;
				}
				this.settleSearch();
				this.settleUseCount();
			},
			showUpdateView:function(item){
				this.theSettleObj = item;
				this.showUpdateFlag = true;
			},
			settleSearch:function(){
				this.settleListLoading = true;
				let url = this.Api.getLastUrl(this.Api.CHARGE_SETTLE_SEARCH_URL);
				let param = {
					neighborId:this.theNeighbor.key,
					startNum:this.startNum,
					endNum:this.endNum,
				};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.settleListLoading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.settleList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.settleListLoading = false;
					console.log(error);
				});
			},
			settleUseCount:function(){
				this.settleUseCountLoading = true;
				let url = this.Api.getLastUrl(this.Api.CHARGE_SETTLE_ALL_USE_COUNT_URL);
				let param = {neighborId:this.theNeighbor.key};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.settleUseCountLoading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.useCountList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.settleListLoading = false;
					console.log(error);
				});
			},
			queryNeighbors:function(){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_SEARCH_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.neighborList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			getMeterState({cellValue}){
				return this.Config.getValueByNameFromList(cellValue,this.Config.getMeterStateList());
			},
			getTimeFormatter({cellValue}){
				if(cellValue == null){
					return "";
				}else{
					let date = new Date(cellValue);
					return this.Config.formatDate(date);
				}
			},
			getUseCount:function(item){
				if(item.changend>0){
					return item.readdata+item.changend-item.deread;
				}else{
					return item.readdata-item.deread;
				}
			},
			filterOption(input, option) {
				return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
			},
			exportException(){
				if(this.theNeighbor == undefined){
					this.$message.error('请选择小区');
					return ;
				}
				this.settleListLoading = true;
				let url = this.Api.getLastUrl(this.Api.CHARGE_SETTLE_EXPORT_EXCEPTION_URL);
				let param = {
					neighborId:this.theNeighbor.key,
				};
				this.Api.fetchPostFile(url,param).then((res)=>{
					this.settleListLoading = false;
					let blob = new Blob([res.data]);
					let downloadElement = document.createElement('a')
					let href = window.URL.createObjectURL(blob); //创建下载的链接
					downloadElement.href = href;
					let fileName = this.theNeighbor.label+'异常数据'+'.xlsx';
					downloadElement.download = fileName; //下载后文件名
					document.body.appendChild(downloadElement);
					downloadElement.click(); //点击下载
					document.body.removeChild(downloadElement); //下载完成移除元素
					window.URL.revokeObjectURL(href); //释放blob对象
				}).catch((error)=>{
					this.settleListLoading = false;
					console.log(error);
				});
			},
		},
		created(){
			this.queryNeighbors();
		},
	}
</script>

<style>
</style>
